import _ from 'lodash'
import { AppIcon  } from '@/shared/ui/icons'

import { truncateName } from '@/shared/lib/string/truncate-name'

export const getTourSteps = progress => [
  {
    target: 'body',
    placement: 'center',
    isFixed: true,
    title: (
      <>
        <span className="text-brand font-bold">
          {truncateName(_.get(progress, 'user.name', ''), 12)}
        </span>
        , sua aventura gamificada está prestes a começar, você está pronto?
      </>
    ),
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    initButton: true,
    initButtonText: 'Sim, estou pronto!'
  },
  {
    target: 'body',
    placement: 'center',
    title: 'Antes de começar, precisamos criar seu avatar',
    content:
      'Vamos te ajudar a criar um avatar para te representar nessa aventura.',
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },
  {
    target: '#avatar-mobile-preview',
    title: 'Pré-visualizácão do seu avatar',
    content:
      'Aqui está um avatar aleatório, você pode customizá-lo como quiser.',
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },
  {
    target: '#avatar-editor-options',
    placement: 'top',
    content: (
      <>
        <span className="block mb-2">
          Aqui estão as opções como corte de cabelo, tipo de camisa, modelo de
          calçado e mais.
        </span>
        <small>Você pode arrastar para o lado para ver todas.</small>
      </>
    ),
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },

  {
    target: '#avatar-editor-style-selector',
    content: (
      <>
        <span className="block mb-2">
          Aqui você pode escolher o estilo da opção selecionada
        </span>
        {/* <small>Você pode arrastar para o lado para ver todas.</small> */}
      </>
    ),
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },
  {
    target: '#avatar-editor-color-selector',
    content: 'E aqui, pode escolher a cor para o estilo selecionado.',
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },
  {
    target: '#avatar-editor-randomize-button',
    content:
      'Caso queira tentar a sorte, você tem a opção de gerar um avatar aleatório clicando aqui.',
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  },
  {
    target: '#avatar-editor-save-button',
    content:
      'Ao final, lembre-se de clicar aqui para salvar seu avatar e continuar a aventura!',
    disableCloseOnEsc: true,
    disableOverlayClose: true,
    hideCloseButton: true
  }
]
